import { Button, Card, Table, Space, notification, Form, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { DELETE, POST } from "../../utils/apicalls";
import LoadingAnimation from "../../componets/loader/loader";

function CustomerReview() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [meta, setMeta] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [reviewdata, setReviewData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "Reviewer Name", dataIndex: "reviwerName" },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    { title: "Summary", dataIndex: "summary" },
    { title: "Star", dataIndex: "star" },
    { title: "Message", dataIndex: "message" },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" onClick={() => confirmDelete(record.id)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const fetchReviews = async (currentPage: number, currentPageSize: number) => {
    try {
      setIsLoading(true);
      const obj = {
        query: "query",
        page: currentPage,
        take: currentPageSize,
      };

      const url = API.LIST_REVIEWS;
      const response: any = await POST(url, obj);

      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = `${API.DELETE_REVIEWS}${id}`;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "Review deleted successfully!" });
        fetchReviews(page, pageSize);
      } else {
        notification.error({
          message: "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = (id: any) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this review?"
    );
    if (confirm) {
      handleDelete(id);
    }
  };

  const filterReviews = async (values: any) => {
    try {
      setIsLoading(true);
      const api = API.FILTER_REVIEWS;
      const response: any = await POST(api, values);

      if (response?.data) {
        setReviewData(response?.data);
      } else {
        console.error("Data not available:", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews(page, pageSize);
  }, [page, pageSize]);

  return (
    <div className="container mt-4">
      {isLoading ? (
        <LoadingAnimation />
      ) : (
        <>
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <h2 className="text-center mb-4">Customer Reviews</h2>

              <Card className="mb-4">
                <Form
                  form={form}
                  layout="inline"
                  onFinish={filterReviews}
                  style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                >
                  <Form.Item name="reviwerName">
                    <Select
                      placeholder="Select reviwer Name"
                      allowClear
                      style={{ width: "200px" }}
                      options={data.map((item: any) => ({
                        value: item.reviwerName,
                        label: item.reviwerName,
                      }))}
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Filter
                    </Button>
                    <Button
                      style={{ marginLeft: 8 }}
                      onClick={() => {
                        form.resetFields();
                        setReviewData([]); // Clear filtered data
                        fetchReviews(page, pageSize);
                      }}
                    >
                      Reset
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
              <Card>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <Table
                    columns={columns}
                    dataSource={reviewdata.length ? reviewdata : data}
                    loading={isLoading}
                    pagination={{
                      current: page,
                      pageSize: pageSize,
                      total: meta?.total,
                      showSizeChanger: true,
                      onChange: (currentPage: number, currentSize: number) => {
                        setPage(currentPage);
                        setPageSize(currentSize);
                      },
                    }}
                    rowKey={(record: any) => record.id || record.reviwerName}
                    scroll={{ x: "max-content" }}
                  />
                </div>
              </Card>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default CustomerReview;
